import React, { useEffect, useState } from "react";
import "./Product_info.css";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import Demo_Product from "../../home/demo_product/Demo_Product";
import Increment_decrement_btn_holder from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { useNavigate } from "react-router-dom";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../features/master/masterSlice";
import { getHomeBanner } from "../../../features/home/homeSlice";
import { postCart } from "../../../features/cart/cartSlice";
import Demo_ProductCategory from "../../home/demo_product/Demo_ProductCategory";
import { variant_type } from "../../../utils/common";

const Product_info = ({
  selectedVariant,
  setSelectedVariant,
  activeSize,
  activeTriple,
  activeMetal,
  setActiveTriple,
  setActiveSize,
  setActiveMetal,
  product,
  avg_rating,
}) => {
  const [activeColor, setActiveColor] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0); // default first card active
  const [activeIndex2, setActiveIndex2] = useState(0); // default first card active

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product-cart?product_id=${product?.id}`);
  };

  const dispatch = useDispatch();

  const [quantity, setQuantity] = useState(1);

  const isSignIn = useSelector((state) => state.auth.is_signin);
  const addToCart = async () => {
    try {
      const data = {
        product_id: product.id,
        variant_type_id: product.variant_type_id,

        // variant_id: selectedVariant?.id,
        quantity: quantity,
      };
      if (Number(product.variant_type_id) === variant_type.Single) {
        data.variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Double) {
        data.d_variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Triple) {
        data.t_variant_id = selectedVariant?.id;
      }
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));

      if (res.meta?.requestStatus === "fulfilled") {
        handleClick();
        if (res?.payload?.data?.success) {
        } else {
        }
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  useEffect(() => {
    if (
      Number(product?.variant_type_id) === variant_type.Single &&
      product?.Product_Variants?.length > 0 &&
      !activeMetal
    ) {
      const first = product.Product_Variants[0];
      setActiveMetal(first);
      setSelectedVariant({
        ...first,
        Product_Images: first.Product_Images || [],
      });
    }
  }, [product]);

  // Auto select first available variant
  // useEffect(() => {
  //   if (activeMetal?.Double_Variants?.length > 0) {
  //     setSelectedVariant(activeMetal?.Double_Variants?.[0]);
  //     setActiveSize(activeMetal?.Double_Variants?.[0]);
  //   }
  // }, [activeMetal]);

  // useEffect(() => {
  //   if (activeSize?.Triple_Variants?.length > 0) {
  //     setSelectedVariant(activeSize.Triple_Variants[0]);
  //     setActiveTriple(activeSize.Triple_Variants[0]);
  //   }
  // }, [activeSize]);

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  return (
    <section className="Product_info">
      <div className="text_holder">
        <h4 className="">{product?.name}</h4>
        <div className="rating_holder">
          <p className="rating_text ">
            <Rating
              className="star_icons "
              initialRating={Number(avg_rating?.average_rating)}
              emptySymbol={<FontAwesomeIcon icon={farStar} color="#fff" />}
              fullSymbol={<FontAwesomeIcon icon={fasStar} color="#fff" />}
              fractions={2}
              readonly
            />
            {Number(avg_rating?.average_rating)} | {avg_rating?.total_counts}{" "}
            Reviews
          </p>
        </div>
        {selectedVariant && (
          <div className="price_holder">
            <h6 className="">
              {symbol} {Number(selectedVariant.price * rate).toFixed(2)} {" "}
              <span className="discounted_price">
                {symbol} {Number(selectedVariant.mrp * rate).toFixed(2)}
              </span>
            </h6>
            <div className="save_div">
              <Green_btn
                btnText={`Save: ${
                  selectedVariant?.mrp > 0
                    ? Math.round(
                        ((Number(selectedVariant.mrp) -
                          Number(selectedVariant.price)) /
                          Number(selectedVariant.mrp)) *
                          100,
                      )
                    : 0
                }%`}
              />
            </div>

            <span className="mrp_holder">MRP (Inclusive of all taxes)</span>
          </div>
        )}
      </div>

      <div>
        {Number(product?.variant_type_id) === variant_type.Single &&
          product?.Product_Variants?.length > 0 && (
            <div className="quantity_holder">
              <p className="type_text">Size</p>
              <div className="d-flex flex-wrap">
                {product.Product_Variants.map((item) => (
                  <div className="sizebox mb-3 me-2" key={item.id}>
                    <div
                      className={`quantity_box_holder 
                ${item.general_stock <= 0 ? "prodnotavailable" : ""} 
                ${activeMetal?.id === item.id ? "active" : ""}
              `}
                      onClick={() => {
                        setActiveMetal(item);
                        setSelectedVariant({
                          ...item,
                          Product_Images: item.Product_Images || [],
                        });
                      }}
                    >
                      <div className="info_holder">
                        <h5>{item?.Metal?.name}</h5>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        {/* COLOUR / METAL - Only for Double & Triple variants */}
        {(Number(product?.variant_type_id) === variant_type.Double ||
          Number(product?.variant_type_id) === variant_type.Triple) && (
          <div className="quantity_holder">
            <p className="type_text">
              {product?.variant_name || "Color"}:{" "}
              {selectedVariant?.Product_Variant?.Metal?.name ||
                selectedVariant?.Size?.name ||
                "Color"}
            </p>

            <div className="d-flex flex-wrap">
              {product?.Product_Variants?.map((option) => (
                <div className="me-1" key={option.id}>
                  <div
                    className={`color_img_holder ${
                      activeMetal?.id === option.id ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveMetal(option);

                      // Reset child selections
                      setActiveSize(null);
                      setActiveTriple(null);

                      if (
                        Number(product?.variant_type_id) === variant_type.Double
                      ) {
                        const firstSize = option?.Double_Variants?.[0];

                        setActiveSize(firstSize);
                        setSelectedVariant(firstSize);
                      }

                      if (
                        Number(product?.variant_type_id) === variant_type.Triple
                      ) {
                        const firstSize = option?.Double_Variants?.[0];
                        const firstTriple = firstSize?.Triple_Variants?.[0];

                        setActiveSize(firstSize);
                        setActiveTriple(firstTriple);
                        setSelectedVariant(firstTriple);
                      }
                    }}
                  >
                    <img
                      className="color_img"
                      alt="color"
                      src={
                        option?.Product_Images?.[0]?.image
                          ? process.env.REACT_APP_IMG_URL +
                            option.Product_Images[0].image
                          : "/assets/images/product_color_varient_img/img_1.webp"
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {product?.Product_Variants?.find((v) => v.id === activeMetal?.id)
          ?.Double_Variants?.length > 0 &&
          Number(product?.variant_type_id) === Number(variant_type.Double) && (
            <div className="quantity_holder">
              <p className="type_text">Size</p>
              <div className="d-flex flex-wrap">
                {product.Product_Variants.find(
                  (v) => v.id === activeMetal?.id,
                ).Double_Variants.map((item) => (
                  <div className="sizebox mb-3 me-2" key={item.id}>
                    <div
                      // className={`quantity_box_holder  prodnotavailable ${
                      //   activeSize?.id === item.id ? "active" : ""
                      // }`}

                      className={`quantity_box_holder 
  ${item.stock <= 0 ? "prodnotavailable" : ""} 
  ${activeSize?.id === item.id ? "active" : ""}
`}
                      onClick={() => {
                        setActiveSize(item);
                        // setActiveTriple(null);
                        if (product?.variant_type_id === variant_type.Double) {
                          setSelectedVariant(item);
                        }
                      }}
                    >
                      <div className="info_holder">
                        <h5>{item?.Size?.name}</h5>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

        <p>
          <strong>Measurement</strong> : {product?.measurements}{" "}
        </p>

        {/* TRIPLE VARIANTS */}
        {product?.Product_Variants?.find(
          (v) => v.id === activeMetal?.id,
        )?.Double_Variants?.find((s) => s.id === activeSize?.id)
          ?.Triple_Variants?.length > 0 &&
          Number(product?.variant_type_id) === Number(variant_type.Triple) && (
            <div className="quantity_holder">
              <p className="type_text">Diamond</p>
              <div className="row">
                {product.Product_Variants.find((v) => v.id === activeMetal?.id)
                  .Double_Variants.find((s) => s.id === activeSize?.id)
                  .Triple_Variants.map((item1) => (
                    <div className="col-sm-3 col-6 mb-3" key={item1.id}>
                      <div
                        className={`quantity_box_holder ${
                          activeTriple?.id === item1.id ? "active" : ""
                        }`}
                        onClick={() => {
                          setActiveTriple(item1);
                          if (
                            product?.variant_type_id === variant_type.Triple
                          ) {
                            setSelectedVariant(item1);
                          }
                        }}
                      >
                        <div className="info_holder">
                          <h5>{item1?.Diamond?.name}</h5>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
      </div>

      <div className="prod_description"></div>

      <div className="btn_holder ">
        <div className="add_cart_btn">
          {(product?.variant_type_id === 1
            ? selectedVariant?.general_stock
            : selectedVariant?.stock) <= 0 ? (
            <Green_btn
              btnText="Out Of Stock"
              product={product}
              // onClick={addToCart}
              quantity={quantity}
              setQuantity={setQuantity}
              selectedVariant={selectedVariant}
            />
          ) : (
            <Green_btn
              btnText="Add to Cart"
              product={product}
              onClick={addToCart}
              quantity={quantity}
              setQuantity={setQuantity}
              selectedVariant={selectedVariant}
            />
          )}
        </div>
        {/* {Number(selectedVariant?.general_stock) >= Number(quantity) ? (
          <Increment_decrement_btn_holder
            quantity={quantity}
            setQuantity={setQuantity}
          />
        ) : (
          <></>
        )} */}
      </div>
    </section>
  );
};

export default Product_info;
